<template>
  <!-- 咨询弹窗组件 -->
  <el-dialog :title="dialogTitle" :visible="visible" :width="dialogWidth" append-to-body @close="closeDialog">
    <!-- 表单区域 -->
    <el-form ref="consultForm" :model="form" :rules="rules" label-width="100px" label-position="right"
      v-loading="loading">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" maxlength="20" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="公司" prop="company">
        <el-input v-model="form.company" placeholder="请输入公司名称" maxlength="50" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="联系方式" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="11" show-word-limit @input="handlePhoneInput"
          @keyup.enter="handlePhoneEnter"></el-input>
      </el-form-item>

      <el-form-item label="业务类型" prop="businessType">
        <el-select style="width: 100%" v-model="form.businessType" placeholder="请选择业务类型" clearable>
          <el-option v-for="(item, i) in businessTypeOptions" :label="item.label" :value="item.value" :key="i">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="需求描述" prop="requirement">
        <el-input type="textarea" v-model="form.requirement" placeholder="请输入需求描述" :rows="4" maxlength="200"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>

    <!-- 底部按钮 -->
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" class="btn" @click="submitForm">{{ confirmText }}</el-button>
        <el-button @click="closeDialog">{{ cancelText }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { addConsultationRecord } from "@/apis/cms";
import { Message } from 'element-ui';

export default {
  name: 'ConsultDialog', // 组件名（必填，用于注册）
  props: {
    // 弹窗是否显示（双向绑定）
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题（可自定义）
    dialogTitle: {
      type: String,
      default: '立即咨询'
    },
    // 弹窗宽度（可自定义）
    dialogWidth: {
      type: String,
      default: '700px'
    },
    // 确认按钮文本（可自定义）
    confirmText: {
      type: String,
      default: '提 交'
    },
    // 取消按钮文本（可自定义）
    cancelText: {
      type: String,
      default: '取 消'
    }
  },
  data() {
    return {
      loading: false,
      businessTypeOptions: [
        { label: '小红书全域运营', value: '1' },
        { label: '达人私域保ROI/CPA', value: '2' },
        { label: '内容跨域整合营销', value: '3' },
      ],
      // 表单数据
      form: {
        name: '',
        company: '',
        phone: '',
        businessType: null,
        requirement: ''
      },
      // 表单校验规则
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '姓名长度为2-20个字符', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 2, max: 50, message: '公司名称长度为2-50个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        businessType: [
          { required: true, message: '请选择业务类型', trigger: 'change' },
        ],
        // requirement: [
        //   {required: true, message: '请输入需求描述', trigger: 'blur'},
        //   {min: 5, max: 200, message: '需求描述长度为5-200个字符', trigger: 'blur'}
        // ]
      }
    }
  },
  methods: {
    handlePhoneInput(e) {
      const val = e.replace(/[^\d]/g, ''); // 过滤非数字
      this.form.phone = val; // 强制同步v-model
      // 手动触发单个字段校验（实时更新校验状态）
      const res = this.$refs.consultForm.validateField('phone');
      console.log('res', res)
    },

    handlePhoneEnter() {
      // 若手机号为空/非法，聚焦输入框并提示
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$refs.consultForm.validateField('phone');
        // 聚焦到手机号输入框（可选，提升体验）
        this.$el.querySelector('input[placeholder="请输入手机号码"]').focus();
      }
    },
    // 提交表单
    submitForm() {
      this.$refs.consultForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let map = this.listToMap(this.businessTypeOptions, 'value', 'label');
          this.form.businessTypeName = map[this.form.businessType];
          addConsultationRecord(this.form).then(res => {
            this.loading = false;
            if (res.code === 200) {
              Message.success('添加成功')
              this.closeDialog();
              // 重置表单（可选，根据需求决定）
              this.resetForm();
            } else {
              Message.error(res.msg)
            }
          })

        } else {
          console.log('表单校验失败');
          return false;
        }
      });
    },

    listToMap(list, keyField, valueField) {
      // 边界处理：非数组直接返回空对象
      if (!Array.isArray(list)) return {};

      return list.reduce((map, item) => {
        if (item && item[keyField] !== undefined && item[valueField] !== undefined) {
          map[item[keyField]] = item[valueField];
        }
        return map;
      }, {});
    },

    // 关闭弹窗
    closeDialog() {
      this.resetForm();
      // 向父组件发送关闭事件（双向绑定同步）
      this.$emit('closeDialog');
    },

    // 重置表单
    resetForm() {
      this.$refs.consultForm.resetFields(); // 重置表单字段和校验状态
      this.form = { name: '', company: '', phone: '', businessType: null, requirement: '' }; // 清空表单数据
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
  /* 按钮居中 */
}

.btn {
  background-color: #E33333;
  border-color: #FF6700;
  border-radius: 10px;
}

/* 适配移动端 */
@media (max-width: 768px) {
  .el-dialog {
    width: 90% !important;
  }
}
</style>
